<template>
  <div>
    <div class="text-subtitle-4 neutral-040--text mb-3 d-flex align-center">
      <v-btn
        icon
        small
        target="_blank"
        class="mr-1"
        :href="omnichatDocs + 'features/omo-she-ding/dian-yuan-pai-ban-guan-li#shang-chuan-ban-biao'"
      >
        <v-icon color="neutral-044">
          mdi-help-circle
        </v-icon>
      </v-btn>
      {{ $t('STAFF_MANAGEMENT.UPLOAD_Roster') }}
    </div>
    <v-form
      ref="form"
      v-model="formValid"
      lazy-validation
    >
      <div class="upload-staff-schedule-content">
        <Select
          :label="$t('STAFF_MANAGEMENT.SHOP_LOCATIONS')"
          :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_SHOP')"
          v-model="uploadLocationCode"
          :items="shopLocationList"
          item-text="name"
          item-value="code"
          solo
          flat
        />
        <Select
          :label="$t('STAFF_MANAGEMENT.MONTH')"
          :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_MONTH')"
          v-model="uploadMonth"
          :items="monthRangeUpload"
          solo
          flat
        >
          <template v-slot:item="{ item }">
            <v-list-item-title
              class="text-body-2"
            >
              {{ item }}
            </v-list-item-title>
          </template>
        </Select>
        <Select
          :label="$t('STAFF_MANAGEMENT.EMPLOYEE_ID_TYPE')"
          :placeholder="$t('STAFF_MANAGEMENT.PLEASE_SELECT_EMPLOYEE_ID_TYPE')"
          v-model="uploadIdField"
          :items="uploadIdFieldList"
          item-text="text"
          item-value="value"
          solo
          flat
        />

        <div class="">
          <div class="upload-input">
            <CSVUploader
              ref="csvUploader"
              class="csv-uploader"
              @csv-uploaded="handleUploadData"
              @csv-upload-error="handleUploadError"
              :require-columns="scheduleRequireColumns"
            />
          </div>
          <div
            v-if="uploadErrorMsg"
            class="d-flex text-body-2 mt-4"
          >
            <v-icon
              class="mr-2"
              color="neutral-042"
              size="18"
            >
              $vuetify.icons.warningIcon
            </v-icon> {{ uploadErrorMsg }}
          </div>
        </div>

        <v-card
          class="py-7 px-4 text-body-3 neutral-041--text"
          color="warning-034"
          min-height="106"
          flat
        >
          <div class="mb-3">
            {{ $t('SHOP_MANAGEMENT.INFO') }}{{ $t('STAFF_MANAGEMENT.FILE_MUST_BE_CSV') }}
          </div>
          <div>
            <a
              class="text-body-2 primary-001--text text-decoration-none"
              :href="scheduleExampleFilePath"
              download
            >{{ $t('STAFF_MANAGEMENT.DOWNLOAD_SAMPLE_ROSTER') }}</a>
          </div>
        </v-card>

        <div class="text-right">
          <v-btn
            @click="$refs.checkModal.openModal();"
            depressed
            :dark="uploadedRecords.length > 0"
            :disabled="uploadedRecords.length === 0"
            color="primary-001"
            class="text-body-2"
            min-width="137"
            max-height="32"
          >
            {{ $t('UPLOAD') }}
          </v-btn>
        </div>
      </div>
    </v-form>
    <Modal
      ref="checkModal"
    >
      <template v-slot:title>
        {{ $t('STAFF_MANAGEMENT.WARNING') }}
      </template>
      <template v-slot:content>
        <v-card-text
          v-html="$t('STAFF_MANAGEMENT.UPLOAD_ROSTER_REMINDER')"
          class="neutral-042--text text-body-1 pa-0 mb-auto"
        />
      </template>
      <template v-slot:actions>
        <v-card-actions class="pa-0 pt-8">
          <v-spacer />
          <v-btn
            color="neutral-045"
            outlined
            @click="$refs.checkModal.closeModal()"
            class="text-body-2 cancel-btn"
          >
            {{ $t('CANCEL') }}
          </v-btn>
          <v-btn
            color="primary-001"
            outlined
            :loading="isSubmitLoading"
            @click="importStaffSchedule"
            class="text-body-2 ml-3"
          >
            {{ $t('CONFIRM') }}
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
    <Notification
      ref="notification"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Select from '@/components/form/Select.vue';
import Modal from '@/components/Modal.vue';
import CSVUploader from '@/components/tool/CSVUploader.vue';
import { ROLE } from '@/utils/constants';
import staffApi from '@/restapis/staffManagement';

const CONST_ID_FIELD = {
  EMPLOYEE_CODE: 'employeeCode',
  PHONE: 'phone',
  EMAIL: 'email'
};

export default {
  name: 'UploadStaffSchedule',
  components: {
    Select,
    CSVUploader,
    Modal
  },
  props: {

  },
  data() {
    return {
      formValid: false,
      isSubmitLoading: false,
      uploadLocationCode: '',
      uploadMonth: this.dayjs().add(1, 'month').format('YYYY-MM'),
      uploadIdField: 'email',
      uploadedRecords: [],
      monthRangeUpload: [],
      shopLocationList: [],
      uploadErrorMsg: '',
      omnichatDocs: this.$t('OMNICHAT_DOCS')
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    }),
    uploadIdFieldList() {
      return [
        {
          text: this.$t('STAFF_MANAGEMENT.EMPLOYEE_ID'),
          value: 'employeeCode'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: this.$t('STAFF_MANAGEMENT.PHONE'),
          value: 'phone'
        }
      ];
    },
    isUploadAllShopSchedule() {
      return this.uploadLocationCode === '';
    },
    scheduleRequireColumns() {
      switch (this.uploadIdField) {
        case CONST_ID_FIELD.EMPLOYEE_CODE:
          if (this.isUploadAllShopSchedule) {
            return ['employeeCode', 'locationCode'];
          }
          return ['employeeCode'];
        case CONST_ID_FIELD.PHONE:
          if (this.isUploadAllShopSchedule) {
            return ['phone', 'locationCode'];
          }
          return ['phone'];
        case CONST_ID_FIELD.EMAIL:
          if (this.isUploadAllShopSchedule) {
            return ['email', 'locationCode'];
          }
          return ['email'];
        default:
          return [];
      }
    },
    scheduleExampleFilePath() {
      switch (this.uploadIdField) {
        case CONST_ID_FIELD.EMPLOYEE_CODE:
          if (this.isUploadAllShopSchedule) {
            return './example-csv/staff-schedule-csv-sample-employeeCode-all-shop.csv';
          }
          return './example-csv/staff-schedule-csv-sample-employeeCode.csv';
        case CONST_ID_FIELD.PHONE:
          if (this.isUploadAllShopSchedule) {
            return './example-csv/staff-schedule-csv-sample-phone-all-shop.csv';
          }
          return './example-csv/staff-schedule-csv-sample-phone.csv';
        case CONST_ID_FIELD.EMAIL:
          if (this.isUploadAllShopSchedule) {
            return './example-csv/staff-schedule-csv-sample-email-all-shop.csv';
          }
          return './example-csv/staff-schedule-csv-sample-email.csv';
        default:
          return './example-csv/staff-schedule-csv-sample-email.csv';
      }
    }
  },
  mounted() {
    this.calculateMonthRangeSelection();
    this.setShopLocationList();
  },
  methods: {
    calculateMonthRangeSelection() {
      // monthRangeUpload last 3, future 3
      for (let i = 3; i >= 0; i--) {
        this.monthRangeUpload.push(this.dayjs().subtract(i, 'month').format('YYYY-MM'));
      }
      for (let i = 1; i <= 3; i++) {
        this.monthRangeUpload.push(this.dayjs().add(i, 'month').format('YYYY-MM'));
      }
      this.monthRangeUpload = this.monthRangeUpload.reverse();
    },
    setShopLocationList() {
      this.shopLocationList = [...this.currentUserDict.shopLocations];
      if (this.currentUserDict.role === ROLE.ADMIN
      || this.currentUserDict.role === ROLE.MANAGER) {
        this.shopLocationList.unshift({ name: this.$t('STAFF_MANAGEMENT.ALL_SHOP'), code: '' });
      } else {
        this.uploadLocationCode = this.shopLocationList[0].code;
      }
    },
    async importStaffSchedule() {
      const payload = {
        month: this.uploadMonth,
        idField: this.uploadIdField,
        records: this.uploadedRecords
      };

      if (this.uploadLocationCode !== '') {
        payload.locationCode = this.uploadLocationCode;
      }

      try {
        this.isSubmitLoading = true;
        let response = null;
        if (this.uploadLocationCode !== '') {
          response = await staffApi.uploadStaffSchedule(payload);
        } else {
          response = await staffApi.uploadAllLocationSchedule(payload);
        }

        const notificationObj = {
          title: this.$t('STAFF_MANAGEMENT.UPLOAD_SUCCESS'),
          status: 'success'
        };
        this.$refs.notification.openNotification(notificationObj);
        this.$refs.csvUploader.resetCsvUploader();
        this.$emit('reload-schedule-report');
        this.uploadedRecords = [];
        this.$refs.checkModal.closeModal();
        this.isSubmitLoading = false;
      } catch (error) {
        this.$refs.checkModal.closeModal();
        this.isSubmitLoading = false;
        if (this.uploadLocationCode !== '') {
          this.handleUploadStaffScheduleError(error.response.data);
        } else {
          this.handleUploadAllLocationScheduleError(error.response.data);
        }
      }
    },
    handleUploadData(result) {
      this.uploadErrorMsg = '';
      this.uploadedRecords = [];

      this.convertJsonToPayload(result);
    },
    handleUploadError(error) {
      this.uploadedRecords = [];
      this.uploadErrorMsg = error;
    },
    convertJsonToPayload(jsonFile) {
      const parseJsonFile = jsonFile.filter((item) => item[this.uploadIdField] !== '');

      if (parseJsonFile.length === 0) {
        this.uploadErrorMsg = this.$t('STAFF_MANAGEMENT.CSV_EMPTY_ROW');
      }

      for (let x = 0; x < parseJsonFile.length; x++) {
        if (this.isUploadAllShopSchedule) {
          // 若是上傳所有分店，會多一個 locationCode 的 row
          this.uploadedRecords.push({
            id: parseJsonFile[x].employeeCode?.trim() || parseJsonFile[x].email?.trim() || parseJsonFile[x].phone?.trim(),
            locationCode: parseJsonFile[x].locationCode,
            time: []
          });
        } else {
          this.uploadedRecords.push({
            id: parseJsonFile[x].employeeCode?.trim() || parseJsonFile[x].email?.trim() || parseJsonFile[x].phone?.trim(),
            time: []
          });
        }

        for (let y = 1; y <= 31; y++) {
          this.uploadedRecords[x].time.push({
            day: y,
            in: parseJsonFile[x][`${y}-In`],
            out: parseJsonFile[x][`${y}-Out`]
          });
        }
      }
    },
    handleUploadStaffScheduleError(response) {
      let errMsg = '';
      switch (response.code) {
        case 13003:
          errMsg = this.$t('STAFF_MANAGEMENT.LOCATION_NOT_FOUND');
          break;
        case 13005:
          errMsg = `${this.$t('STAFF_MANAGEMENT.ERR0R_EMPLOYEE_NOT_IN_SELECTED_LOCATION')}: \n ${response.data.join(', ')}`;
          break;
        case 13006:
          errMsg = this.$t('STAFF_MANAGEMENT.NOT_PERMISSION');
          break;
        case 13008:
          errMsg = this.$t('STAFF_MANAGEMENT.SHOP_NOT_FOUND');
          break;
        case 13022:
          errMsg = `${this.$t('STAFF_MANAGEMENT.UPLOAD_SCHEDULE_TIME_FORMAT_ERROR')}: \n ${response.data.join('<br>')}`;
          break;
        default:
          errMsg = `${response.code}-${response.message}`;
          break;
      }
      const notificationObj = {
        title: this.$t('STAFF_MANAGEMENT.UPLOAD_ROSTER_ERROR'),
        content: errMsg
      };
      this.$refs.notification.openNotification(notificationObj);
    },
    handleUploadAllLocationScheduleError(response) {
      let errMsg = '';
      switch (response.code) {
        case 13003:
          errMsg = this.$t('STAFF_MANAGEMENT.LOCATION_NOT_FOUND');
          break;
        case 13006:
          errMsg = `${this.$t('STAFF_MANAGEMENT.NOT_PERMISSION')}`;
          break;
        case 13022:
          errMsg = `${this.$t('STAFF_MANAGEMENT.UPLOAD_SCHEDULE_TIME_FORMAT_ERROR_TITLE')} ${this.$t('STAFF_MANAGEMENT.UPLOAD_SCHEDULE_TIME_FORMAT_ERROR_TITLE')} ${response.data.join(',')}`;
          break;
        case 13015:
          errMsg = `${this.$t('STAFF_MANAGEMENT.STAFF_NOT_IN_TEAM')} ${response.data.join(',')}`;
          break;
        default:
          errMsg = `${response.code}-${response.message}`;
          break;
      }
      const notificationObj = {
        title: this.$t('STAFF_MANAGEMENT.UPLOAD_ROSTER_ERROR'),
        content: errMsg
      };
      this.$refs.notification.openNotification(notificationObj);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-staff-schedule-content {
  > *:not(:last-child) {
    margin-bottom: 24px;
  }
}

.upload-input, .csv-uploader {
  min-height: 103px;
  padding: 4px;
}

::v-deep.cancel-btn {
  .v-btn__content {
    color: $neutral-cold-051;
  }
}
</style>
